import { useState, useEffect } from 'react';
import { ShieldAlert, X } from 'lucide-react';
import apiV2 from '../utils/apiV2';

const SNOOZE_KEY = 'twofaNudgeSnoozedUntil';

export const TwoFANudgeBanner = ({ onSetup }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const snoozed = parseInt(localStorage.getItem(SNOOZE_KEY) || '0', 10);
    if (snoozed > Date.now()) return;
    if (!localStorage.getItem('jwtToken')) return;
    apiV2.get('/auth/account/2fa/status')
      .then(({ data }) => {
        const hasMethod = data.otp_enabled || data.totp_enabled || (data.passkeys || 0) > 0 || (data.security_keys || 0) > 0;
        if (data.org_enforced && !hasMethod) setShow(true);
      })
      .catch(() => {});
  }, []);

  if (!show) return null;

  const snooze = () => {
    localStorage.setItem(SNOOZE_KEY, String(Date.now() + 7 * 24 * 3600 * 1000));
    setShow(false);
  };

  return (
    <div
      className="bg-blue-50 border-b border-blue-200 px-3 sm:px-4 py-2.5 flex items-center gap-2 sm:gap-3 flex-shrink-0"
      data-testid="twofa-nudge-banner"
    >
      <ShieldAlert className="w-4 h-4 text-blue-600 shrink-0" />
      <p className="text-xs sm:text-sm text-blue-900 flex-1 min-w-0 leading-snug">
        <span className="font-semibold">Your organization requires two-factor authentication.</span>{' '}
        <span className="hidden sm:inline">You're getting one-time codes for now — add your phone number and pick the method you prefer.</span>
      </p>
      <button
        onClick={onSetup}
        data-testid="twofa-nudge-setup"
        className="text-xs font-semibold bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-full transition-colors shrink-0"
      >
        Choose method
      </button>
      <button
        onClick={snooze}
        data-testid="twofa-nudge-dismiss"
        aria-label="Dismiss for a week"
        className="p-1 rounded-full text-blue-400 hover:text-blue-700 hover:bg-blue-100 transition-colors shrink-0"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default TwoFANudgeBanner;
